import Vue from 'vue';
import App from './App.vue';
import VueWaypoint from 'vue-waypoint';
import VueRouter from 'vue-router';

import Home from '@/pages/Home.vue';
import Experience from '@/pages/Experience.vue';
import Projects from '@/pages/Projects.vue';
import Services from '@/pages/Services.vue';
import Skills from '@/pages/Skills.vue';
import Jesus from '@/pages/Jesus.vue';
import Rates from '@/pages/Rates.vue';
import Demo from '@/pages/Demo.vue';
import Bean from '@/pages/Bean.vue';

// Waypoint plugin
Vue.use(VueWaypoint)
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    { name: 'home', path: '/', component: Home },
    { name: 'experience', path: '/experience', component: Experience },
    { name: 'projects', path: '/projects', component: Projects },
    { name: 'services', path: '/services', component: Services },
    { name: 'skills', path: '/skills', component: Skills },
    { name: 'jesus', path: '/jesus', component: Jesus },
    { name: 'rates', path: '/rates', component: Rates },
    { name: 'demo', path: '/demo', component: Demo },
    { name: 'bean', path: '/truth', component: Bean },
  ]
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router: router
}).$mount('#app');
